import { Box, InputAdornment, Stack, TextField } from '@mui/material';
import { FilterProps, getDateFilterValue } from 'components/external-reference/Filter';
import IconMi from 'components/common/icon/IconMi';
import React, { useContext, useMemo } from 'react';
import DatePicker from 'components/common/date-picker/DatePicker';
import useBundleTranslation from 'i18n';
import moment from 'moment';
import { BlocksContext, IBlocksContext } from '@report-content';

export default function DateRangeFilter({ filter, onFilterChange }: FilterProps) {
    const { t } = useBundleTranslation();
    const defaultFormat = filter.showTimepicker ? 'yyyy-MM-dd  HH:mm:ss' : 'yyyy-MM-dd';

    let startDate = getDateFilterValue(filter);
    if (startDate == null || isNaN(startDate.getTime())) {
        startDate = null;
    }

    let endDate = getDateFilterValue(filter, 1);
    if (endDate == null || isNaN(endDate.getTime())) {
        endDate = null;
    }

    const handleChange = (newValue: Date | null, index: number) => {
        const v = moment(newValue).isValid() ? moment(newValue).format('yyyy-MM-DD') : null;
        const start = moment(startDate).isValid() ? moment(startDate).format('yyyy-MM-DD') : null;
        const end = moment(endDate).isValid() ? moment(endDate).format('yyyy-MM-DD') : null;
        onFilterChange(filter.filterId, [index == 0 ? v : start, index == 1 ? v : end]);
    };

    const blocksContext = useContext<IBlocksContext | null>(BlocksContext);
    const dateFormat: string = useMemo(() => {
        if (!blocksContext) {
            return dateFormat;
        }
        return blocksContext.getFilterMask(defaultFormat, filter.name);
    }, [blocksContext, defaultFormat]);

    const calendarProps = {
        showTimeSelect: filter.showTimepicker,
        // dateFormat: filter.format ?? 'MM/dd/yy',
        dateFormat: dateFormat,
        customInput: (
            <TextField
                fullWidth
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconMi icon="calendar" fontSize="16" />
                        </InputAdornment>
                    ),
                }}
            />
        ),
    };

    return (
        <Stack
            spacing={1}
            direction={'row'}
            sx={{
                '.react-datepicker-wrapper, div.MuiInputBase-root': {
                    width: '100%',
                },
            }}
        >
            <Box flexGrow={1}>
                <DatePicker
                    {...calendarProps}
                    selected={startDate}
                    onChange={(value) => handleChange(value, 0)}
                    maxDate={endDate == null ? undefined : endDate}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{t('to')}</Box>
            <Box flexGrow={1}>
                <DatePicker
                    {...calendarProps}
                    selected={endDate}
                    onChange={(value) => handleChange(value, 1)}
                    minDate={startDate == null ? undefined : startDate}
                />
            </Box>
        </Stack>
    );
}
